export const Home = ({ className }: { className?: string }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="m17.6317 5.41717c-.3162-.26934-.7172-.41717-1.1317-.41717s-.8155.14783-1.1317.41717l-8.74997 7.45963c-.19375.165-.34942.3705-.4562.6021s-.1621.4838-.16213.739v11.0236c0 .4664.18437.9137.51256 1.2434.32819.3298.77331.5151 1.23744.5151h5.5417c.232 0 .4546-.0926.6187-.2575s.2563-.3886.2563-.6218v-7.3271h4.6666v7.3271c0 .4854.392.8793.875.8793h5.5417c.4641 0 .9092-.1853 1.2374-.5151.3282-.3297.5126-.777.5126-1.2434v-11.0236c0-.2552-.0554-.5074-.1621-.739-.1068-.2316-.2625-.4371-.4562-.6021z"
        fill="currentColor"
      />
    </svg>
  );
};
